module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/014-wales-9069860f2d29d67d502c1994ef3938c8.svg";